<template>
  <div id="sdk">
    <Menu v-if="$route.query.p !== 'app'"></Menu>
    <div class="banner" v-if="Object.keys(configs).length > 0">
      <div class="title">
        <h1>下载ToDesk客户端</h1>
        <div v-if="isIos">
          <img class="main_pic" src="../assets/download/iOS.png" alt="" />
          <a :href="configs.ios_link" type="button"
            ><img
              src="../assets/download/iOS_icon_1.png"
              alt=""
            />iPhone版下载</a
          >
          <p>
            当前版本：{{ configs.ios_version }} 更新日期：{{
              configs.ios_release_date
            }}
          </p>
          <a class="log" :href="configs.ios_link"
            >更新日志 <img src="../assets/download/Update_log.png" alt=""
          /></a>
        </div>
        <div v-else>
          <img class="main_pic" src="../assets/download/Android.png" alt="" />
          <a :href="configs.android_link" type="button"
            ><img
              src="../assets/download/android_icon2.png"
              alt=""
            />Android版下载</a
          >
          <p>
            当前版本：{{ configs.android_version }}（正式版） 更新日期：{{
              configs.android_release_date
            }}
          </p>
          <a class="log" href="https://update.todesk.com/android/uplog.html"
            >更新日志 <img src="../assets/download/Update_log.png" alt=""
          /></a>
        </div>
        <h3></h3>
        <p class="mention">其他系统请前往Web端下载：www.todesk.com</p>
        <ul>
          <li><img src="../assets/download/windows_icon.png" alt="" /></li>
          <li><img src="../assets/download/macOS_icon.png" alt="" /></li>
          <li><img src="../assets/download/android_icon.png" alt="" /></li>
          <li><img src="../assets/download/iOS_icon.png" alt="" /></li>
          <li><img src="../assets/download/Linux_icon.png" alt="" /></li>
          <li><img src="../assets/download/tv_icon.png" alt="" /></li>
        </ul>
      </div>
      <img src="../assets/download/backgound.png" width="100%" alt="" />
    </div>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import { dealConfig } from "../utils/util";
export default {
  components: {
    Menu,
  },
  data() {
    return {
      configs: {},
      isIos: false,
    };
  },
  async created() {
    let u = navigator.userAgent;
    if (u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1) {
      this.isIos = true;
      await this.getConfig("ios");
    } else {
      await this.getConfig("android");
    }
  },
  methods: {
    async getConfig(name) {
      try {
        let res = await this.$serve.getConfig({
          type: 1,
          name: name,
        });
        this.configs = dealConfig(res.data.list, 1);
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  position: relative;
}
.banner .title {
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  text-align: center;
}
.banner .title .main_pic {
  width: 150px;
  height: auto;
  margin-top: 10px;
}
.banner .title h1 {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #141c40;
  opacity: 1;
}
.banner .title a[type="button"] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 195px;
  height: 60px;
  background: #0070f9;
  border-radius: 8px;
  border: none;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  margin: 20px auto;
  margin-bottom: 0;
  &:active {
    opacity: 0.8;
  }
}
.banner .title a[type="button"] img {
  width: 30px;
  height: 30px;
  margin-right: 12px;
}
.banner .title p {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #83888f;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.banner .title a.log {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #83888f;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.banner .title a.log img {
  width: 10px;
  height: 10px;
}
.banner .title p img {
  width: 11px;
  height: 11px;
  margin-left: 3px;
}
.banner .title h3 {
  width: 327px;
  height: 0;
  border-bottom: 1px solid #ebedf0;
  margin: auto;
  margin-top: 20px;
}
.banner .title ul {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 30px;
}
.banner .title ul li {
  margin-right: 25px;
}
.banner .title ul li:last-child {
  margin: 0;
}
.banner .title ul li img {
  width: 30px;
  height: 30px;
}
.banner .title p.mention {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e6166;
  line-height: 20px;
}
</style>
